import React from "react";
import { Localize } from "components/service";


const StaffManagementStatusField = ({ status }) => (
    <span className={ `staff-lifecycle-status staff-lifecycle-status--${ status || "unknown" }` }>
        <Localize>{ `STAFF_MANAGEMENT.Status_${ status || "unknown" }` }</Localize>
    </span>
);

export default StaffManagementStatusField;
